import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=05156ab8&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
import style0 from "./Top.vue?vue&type=style&index=0&id=05156ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05156ab8",
  null
  
)

export default component.exports